import React from 'react';
import { Assets, Colors, FontFamily, Modal, PrimaryButton } from 'utils/imports.utils';
import { ButtonSize, ButtonTypes } from 'utils/interface.utils';
import { STRINGS } from 'constants/strings.constant';
import { UnsavedChangesPopupProps } from 'interfaces/profile.interface';
import './unsaved_changes_popup.component.scss';

const UnsavedChangesPopup = (props: UnsavedChangesPopupProps) => {
  return (
    <Modal isOpen={props.isOpen} onClose={props.isSaving ? undefined : props.onClose}>
      <div className="unsaved_changes_popup">
        <img
          className={`unsaved_changes_popup_close ${props.isSaving ? 'unsaved_changes_popup_close_disabled' : ''}`}
          src={Assets.close}
          alt={STRINGS.accountSettings.close}
          onClick={() => {
            if (!props.isSaving) props.onClose();
          }}
        />
        <div className="unsaved_changes_popup_body">
          <div className="unsaved_changes_popup_icon" aria-hidden="true">
            !
          </div>
          <div className="unsaved_changes_popup_content">
            <div className="unsaved_changes_popup_title">
              {STRINGS.accountSettings.unsavedChangesTitle}
            </div>
            <div className="unsaved_changes_popup_text">
              {STRINGS.accountSettings.unsavedChangesMessage}
            </div>
          </div>
        </div>
        <div className="unsaved_changes_popup_buttons">
          <div className="unsaved_changes_popup_buttons_discard">
            <PrimaryButton
              onClick={props.onDiscard}
              text={STRINGS.accountSettings.discardChanges}
              type={ButtonTypes.OUTLINED}
              color={Colors.error}
              style={{ borderColor: Colors.error }}
              size={ButtonSize.MEDIUM}
              fontFamily={FontFamily.medium}
              lineHeight="20px"
              disabled={props.isSaving}
            />
          </div>
          <div className="unsaved_changes_popup_buttons_save">
            <PrimaryButton
              onClick={props.onSave}
              text={STRINGS.accountSettings.save}
              type={ButtonTypes.OUTLINED}
              color={Colors.fontPrimary}
              style={{ borderColor: Colors.fontPrimary }}
              size={ButtonSize.MEDIUM}
              fontFamily={FontFamily.medium}
              lineHeight="20px"
              disabled={props.isSaving}
              activity={props.isSaving}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default UnsavedChangesPopup;
